import * as React from 'react'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from '../../_shared/Container'
import { DIGGER } from '../content'
import { useStatsTracking } from '../tracking'
import styles from './DataDigger.module.css'

export function DataDigger(): React.ReactElement {
  const tracking = useStatsTracking()
  return (
    <section className={styles.digger}>
      <Container className={styles.digger__grid}>
        <div>
          <p className={styles.digger__kicker}>{DIGGER.kicker}</p>
          <h2 className={styles.digger__title}>
            Crowdfunding, confiance et transparence sont des mots qui vont très bien ensemble.
          </h2>
          {DIGGER.paragraphs.map((paragraph) => (
            <p key={paragraph} className={styles.digger__body}>
              {paragraph}
            </p>
          ))}
          <a className={styles.digger__link} href={DIGGER.cta.href} onClick={tracking.dataRequestClick}>
            {DIGGER.cta.label}
            <plume.glyphs.stroke.ArrowRight size={15} />
          </a>
        </div>
        <div className={styles.digger__aside}>
          <h3 className={styles.digger__asideTitle}>{DIGGER.aside.title}</h3>
          <p className={styles.digger__asideBody}>{DIGGER.aside.body}</p>
        </div>
      </Container>
    </section>
  )
}
